import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  fullWidth = false,
  className = '',
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-sans font-bold uppercase tracking-wider transition-all duration-300 min-h-[48px] px-8 py-3 rounded-sm text-sm';
  const variants = {
    primary: 'bg-gold text-white hover:bg-gold-hover shadow-sm hover:shadow-md',
    secondary: 'bg-jade text-white hover:bg-jade/90 shadow-sm',
    outline: 'border border-gold text-gold hover:bg-gold hover:text-white'
  };
  const widthClass = fullWidth ? 'w-full' : 'w-full md:w-auto';
  return <button className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} {...props} data-id="element-234">
      {children}
    </button>;
}